//@flow
const RESIZE_THRESHOLD = 20;
const RESIZER_WIDTH = 6;

export class ColumnResizeHelper {
    static getDefaultWidths({
        containerWidth,
        leftPaneWidth
    }): {
        leftPaneWidth: number,
        rightPaneWidth: number,
        columnResizerPosition: { x: number, y: number }
    } {
        return {
            leftPaneWidth,
            rightPaneWidth: containerWidth - leftPaneWidth,
            columnResizerPosition: {
                x: leftPaneWidth - RESIZER_WIDTH,
                y: 0
            }
        };
    }

    static getWidthsFromScreenSizeState({
        screenSizeState,
        containerWidth,
        leftPaneMinWidth,
        defaultRatio
    }): {
        leftPaneWidth: number,
        rightPaneWidth: number,
        columnResizerPosition: { x: number, y: number }
    } {
        let _leftPaneWidth = 0;
        switch (screenSizeState) {
            case ScreenSizeStates.Min:
                _leftPaneWidth = leftPaneMinWidth;
                break;
            case ScreenSizeStates.Max:
                _leftPaneWidth = containerWidth;
                break;
            case ScreenSizeStates.Default:
            default:
                _leftPaneWidth = containerWidth * defaultRatio;
        }
        _leftPaneWidth =
            _leftPaneWidth < leftPaneMinWidth
                ? leftPaneMinWidth
                : _leftPaneWidth;
        return ColumnResizeHelper.getDefaultWidths({
            containerWidth,
            leftPaneWidth: _leftPaneWidth
        });
    }

    static getNewScreenSizeState({
        screenSizeState,
        currentXPos,
        containerWidth,
        defaultRatio,
        leftPaneMinWidth
    }) {
        const newLeftPaneWidth = currentXPos + RESIZER_WIDTH;
        const defaultLeftPaneWidth = containerWidth * defaultRatio;
        switch (screenSizeState) {
            case ScreenSizeStates.Default: {
                if (
                    newLeftPaneWidth <
                    defaultLeftPaneWidth - RESIZE_THRESHOLD
                ) {
                    // if width < defaultWidth set to min
                    return ScreenSizeStates.Min;
                } else if (
                    newLeftPaneWidth >
                    defaultLeftPaneWidth + RESIZE_THRESHOLD
                ) {
                    // if width increases, set to max
                    return ScreenSizeStates.Max;
                }
                return ScreenSizeStates.Default;
            }
            case ScreenSizeStates.Min: {
                if (newLeftPaneWidth > leftPaneMinWidth) {
                    if (newLeftPaneWidth > defaultLeftPaneWidth) {
                        // if width > defaultWidth, set to max
                        return ScreenSizeStates.Max;
                    }
                    // if  minWidth < width < defaultWidth
                    return ScreenSizeStates.Default;
                }
                return ScreenSizeStates.Min;
            }
            case ScreenSizeStates.Max: {
                if (newLeftPaneWidth < containerWidth) {
                    if (newLeftPaneWidth < defaultLeftPaneWidth) {
                        // if width < defaultWidth, set to min
                        return ScreenSizeStates.Min;
                    }
                    // if  defaultWidth < width < maxWidth, set to default
                    return ScreenSizeStates.Default;
                }
                return ScreenSizeStates.Max;
            }
        }
    }
}

export type ScreenSizeStatesType = 'DEFAULT' | 'MIN' | 'MAX';

export const ScreenSizeStates = {
    Default: 'DEFAULT',
    Min: 'MIN',
    Max: 'MAX'
};

export default ColumnResizeHelper;
